module.exports = __webpack_public_path__ + "static/media/counter-news-icon.65de5111.svg";